import useRemoteOfficeNotification from './hooks/use-remote-office-notification'
import NotificationFilterForm from './NotificationFilterForm'
import NotificationTable from './NotificationTable'

export default function RemoteOfficeNotification() {
  const {
    selectedStatus,
    setSelectedStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    fetchTableList,
    data,
    loading,
  } = useRemoteOfficeNotification()

  return (
    <div className="mb-4">
      <NotificationFilterForm
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        getTableList={fetchTableList}
      />

      <NotificationTable
        data={data}
        selectedStatus={selectedStatus}
        getTableData={fetchTableList}
        endDate={endDate}
        loading={loading}
        startDate={startDate}
      />
    </div>
  )
}
